
import { categoriaApi } from "../../apis";
import Swal from "sweetalert2";





export const categoriaXID = async(id) => {
    try {
        const { data } = await categoriaApi.get(`/categoria/${id}`);
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}



export const categoriasSeccionCompras = async(termino) => {
    try {
        const params = new URLSearchParams();
        params.append('termino',  termino);
        const { data } = await categoriaApi.get(`/sin-terminado`, { params });

        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}




export const listadoTodosCategorias = async({ page=0, termino='' }) => {
    try {
        const params = new URLSearchParams();
        params.append('page',  page.toString());
        params.append('termino',  termino);

        const { data } = await categoriaApi.get('/todos', { params });
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}





export const listadoCategoriasSelect = async() => {
    try {
        const { data } = await categoriaApi.get('/select');
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}





export const startSavingCategoria = async( datos ) => {
    try {
        await categoriaApi.post('new', datos);
        Swal.fire('Exitoso', 'Categoria Creada', 'success');
        return true;
    } catch (error) {
        console.log(error);
        Swal.fire('Error', error.response.data?.msg || '', 'error');
        return false;
    }
} 





export const startEditarCategoria = async(categoria) => {
    try {
        const formData = new FormData();
        if (categoria?.img && typeof categoria?.img !== 'string') {
            formData.append('images', categoria.img);
        }

        Object.entries(categoria).forEach(([key, value]) => {
            formData.append(key, value?.toString());
        });
        await categoriaApi.put(`/${categoria.id}`, formData);
        Swal.fire('Exitoso', 'Categoria Actualizado', 'success');
        return true;

    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}
